import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { getMMT_HLD_OBJ } from '../../../../common/utils/appUtils';

import './styles.scss';

const ListingBanner = props => {
  const { headerDetail, isBannerShow, bannerForwaredRef, h1Header } = props;
  const { fromSEO } = getMMT_HLD_OBJ();
  const bannerShowHide = isBannerShow ? '' : 'bannerShowStyle';

  const headerText = useMemo(() => {
    let headerTextValue = headerDetail?.mainTitle;
    if (fromSEO) {
      headerTextValue = h1Header;
    }

    if (!headerTextValue) {
      headerTextValue = 'Holiday Packages';
    }

    return headerTextValue;
  }, [headerDetail, h1Header]);

  return (
    <>
      <div className="scrollBg" />
      <div
        ref={bannerForwaredRef}
        className={`listingBannerimg ${bannerShowHide}`}
        style={{
          backgroundImage: headerDetail?.image ? `url('${headerDetail?.image}')` : 'none',
          backgroundColor: '#041422',
        }}
      >
        <div className="listingBannerDetails">
          {/* {fromSEO && <BreadCrum />}   moved below FAQs */}
          <div className="listingHeadingSection">
            <div className="listingHeading">
              <h1>{headerText}</h1>
              <p>{headerDetail?.tagLine}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = ({ metadata, seo }) => ({
  headerDetail: metadata?.headerDetail,
  h1Header: seo?.metaData?.h_1_header,
});

export default connect(mapStateToProps, null)(ListingBanner);
